<template>
  <v-container fluid class="subscribe-container pa-0 ma-0">
    <!-- Modern Header -->
    <div
      v-if="showHeader"
      class="header-section mb-6"
      style="margin: 0 12px; position: relative;"
    >
      <v-btn icon small class="header-close-btn" @click="dismissHeader">
        <v-icon color="white">mdi-close</v-icon>
      </v-btn>
      <div class="d-flex align-center mb-4">
        <div class="header-icon-wrapper mr-4">
          <v-icon size="32" color="#FFFFFF">mdi-credit-card</v-icon>
        </div>
        <div>
          <h1 class="page-title mb-1">Subscribe</h1>
          <p class="page-subtitle mb-0">
            Manage your plan, billing, and subscription details
          </p>
        </div>
        <v-spacer></v-spacer>
        <div class="d-none d-sm-flex">
          <v-chip
            class="mr-2 white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">{{
              isActive ? "mdi-check-circle" : "mdi-alert-circle"
            }}</v-icon>
            {{ isActive ? "Active" : "Inactive" }}
          </v-chip>
          <v-chip
            class="white--text"
            color="white"
            small
            style="background: rgba(255,255,255,0.25) !important; border: 1px solid rgba(255,255,255,0.5);"
          >
            <v-icon left x-small color="white">mdi-shield-check</v-icon>
            Secure
          </v-chip>
        </div>
      </div>

      <!-- Feature Pills -->
      <v-row class="feature-pills ma-0">
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-package-variant</v-icon
            >
            <span>Plan Details</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-credit-card</v-icon
            >
            <span>Payment Method</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-account-group</v-icon
            >
            <span>Members</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2"
              >mdi-calendar-clock</v-icon
            >
            <span>Billing Cycle</span>
          </div>
        </v-col>
        <v-col cols="6" sm="4" md="2" class="pa-1">
          <div class="feature-pill">
            <v-icon size="18" color="white" class="mr-2">mdi-wallet</v-icon>
            <span>Invoices</span>
          </div>
        </v-col>
      </v-row>
    </div>

    <v-row class="ma-0 pa-0" style="padding: 0 12px;">
      <!-- Subscribed Plan and User Profile  -->
      <v-col v-if="showZoho" cols="12" md="7">
        <v-row class="pt-2">
          <v-col cols="12" md="4">
            <v-card
              color="secondarygrad"
              class="customBorderRadius rounded align-center pa-6 pt-4"
              style="min-height: 122px;"
            >
              <h3 style="color:#30475A;" class="blue-black">
                Cycle
              </h3>
              <div class="pt-2" style="color: grey;">
                {{ companyDetails.plan.name }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card
              color="secondarygrad"
              class="customBorderRadius rounded align-center pa-6 pt-4"
              style="min-height: 122px;"
            >
              <h3 style="color:#30475A;" class="blue-black">
                Expiry
              </h3>
              <div class="pt-2" style="color: grey;">
                {{ companyDetails.plan.expiryDate | moment("lll") }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card
              color="secondarygrad"
              class="customBorderRadius rounded align-center pa-6 pt-4"
            >
              <h3 style="color:#30475A;" class="blue-black">
                Member Limit
              </h3>
              <div class="pt-2" style="color: grey;">
                {{ companyDetails.plan.userLimit }}
              </div>
              <div
                style="display: flex; justify-content: flex-end; margin-top: -6px; color: grey;font-size: 16px;"
              >
                <span class="liveAccount" style="margin-top: 7px;"></span>
                <i v-if="originalUserCount > 1"
                  >{{ originalUserCount }} added users</i
                >
                <i v-else-if="originalUserCount <= 1"
                  >{{ originalUserCount }} added user</i
                >
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="pt-2">
          <v-col>
            <zoho-subscription
              v-if="showZoho"
              ref="zohoSubscriptionBox"
              @update-original-user-count="handleOriginalUserCountUpdate"
            />
            <!-- <paddle-subscription
              v-else
              @update-original-user-count="handleOriginalUserCountUpdate"
            /> -->
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="!showZoho" cols="12" md="12">
        <v-row class="pt-2">
          <v-col cols="12" md="4">
            <v-card
              color="secondarygrad"
              class="customBorderRadius rounded align-center pa-6 pt-4"
              style="min-height: 122px;"
            >
              <h3 style="color:#30475A;" class="blue-black">
                Cycle
              </h3>
              <div class="pt-2" style="color: grey;">
                {{ companyDetails.plan.name }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card
              color="secondarygrad"
              class="customBorderRadius rounded align-center pa-6 pt-4"
              style="min-height: 122px;"
            >
              <h3 style="color:#30475A;" class="blue-black">
                Expiry
              </h3>
              <div class="pt-2" style="color: grey;">
                {{ companyDetails.plan.expiryDate | moment("lll") }}
              </div>
            </v-card>
          </v-col>

          <v-col cols="12" md="4">
            <v-card
              color="secondarygrad"
              class="customBorderRadius rounded align-center pa-6 pt-4"
            >
              <h3 style="color:#30475A;" class="blue-black">
                Member Limit
              </h3>
              <div class="pt-2" style="color: grey;">
                {{ companyDetails.plan.userLimit }}
              </div>
              <div
                style="display: flex; justify-content: flex-end; margin-top: -6px; color: grey;font-size: 16px;"
              >
                <span class="liveAccount" style="margin-top: 7px;"></span>
                <i v-if="originalUserCount > 1"
                  >{{ originalUserCount }} added users</i
                >
                <i v-else-if="originalUserCount <= 1"
                  >{{ originalUserCount }} added user</i
                >
              </div>
            </v-card>
          </v-col>
        </v-row>

        <v-row class="pt-2">
          <v-col>
            <!-- <zoho-subscription
              v-if="showZoho"
              ref="zohoSubscriptionBox"
              @update-original-user-count="handleOriginalUserCountUpdate"
            /> -->
            <paddle-subscription
              @update-original-user-count="handleOriginalUserCountUpdate"
            />
          </v-col>
        </v-row>
      </v-col>

      <v-col v-if="showZoho" cols="12" md="5">
        <payment-profile
          @update-original-user-count="handleOriginalUserCountUpdate"
        />

        <!-- <promo-code
          v-if="showZoho"
          @updateBill="$refs.zohoSubscriptionBox.getBillingCost()"
          @update-original-user-count="handleOriginalUserCountUpdate"
        /> -->
      </v-col>

      <v-col v-if="showZoho" cols="12" md="12" style="padding-top: 20px;">
        <h2 align="center" style="padding-bottom: 20px;">
          Frequently Asked Questions
        </h2>
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >How many calls can I make per member?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              Unlimited number of calls can be made by a member with the GoDial
              Cloud Call Recording Subscription.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >Can I change the limit during my tenure?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              Yes, you can upgrade or downgrade your plan post the completion of
              your subscription. For example, if you have taken a Monthly
              Subscription, you will have to wait for 30 days before you can
              change the plan. Please contact our support team to discuss plan
              changes and any associated costs.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >Is Recording available? What is Cloud Recording?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              Yes, GoDial Cloud Call Recording is a key feature. It allows you
              to record calls directly within the GoDial app. Your calls are
              securely recorded and stored in the cloud, accessible from any
              device with an internet connection. This eliminates the need for
              local storage or manual transfers.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b>How many contacts can I add?</b></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              You can add an unlimited number of contacts to your GoDial
              account. Though we suggest not to keep more than 300,000 contacts
              at a single point of time, as it overloads the server and can lead
              to longer loading times for lists and reports.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >Can I cancel the plan in between?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              Yes, you can choose to discontinue with GoDial at any point of
              time. Please note - No amount will be refunded for the unused
              period of the subscription. If you purchase a monthly plan and
              only use it for a week, no amount will be refunded for the
              remaining unused period.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >What devices are compatible with GoDial Cloud Call
                Recording?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              GoDial Cloud Call Recording is compatible with all smartphones
              running on Android.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >Is there any storage limit for call recordings?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              No, there is no storage limit for call recordings. However, we
              encourage responsible data management to ensure optimal
              performance.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >How secure is my call recording data?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              GoDial employs industry-standard security measures to protect your
              call recordings, including encryption and access controls.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b>Can I download call recordings?</b></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              Yes, you can download call recordings for easy access and sharing.
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="customBorderRadius mb-2">
            <v-expansion-panel-header
              ><b
                >What happens if I have a poor internet connection during a
                call?</b
              ></v-expansion-panel-header
            >
            <v-expansion-panel-content>
              If you encounter poor internet connectivity, the call recording
              may be interrupted or incomplete. We recommend using a stable
              Wi-Fi connection for optimal recording quality.
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import zohoSubscription from "../components/subscription/ZohoSubscription.vue";
import paymentProfile from "../components/subscription/PaymentProfile.vue";
import PaddleSubscription from "../components/subscription/PaddleSubscription.vue";
import promoCode from "../components/subscription/promocode.vue";
export default {
  components: {
    zohoSubscription,
    paymentProfile,
    PaddleSubscription,
    promoCode,
  },
  data() {
    return {
      showHeader: false,
      tabs: null,
      tabs1: null,
      panel: [],
      switch1: true,
      name: "",
      checkbox: true,
      originalUserCount: 1,
      slider: 1,
      text:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      paymentType: [
        { name: "Automatic Payments", value: "automatic" },
        { name: "Manual Payment", value: "manual" },
      ],
      showZoho: true,
      // lastPlan: {},
    };
  },
  computed: {
    moneyTrial() {
      return require("../assets/moneyTrial.png");
    },
    paperplane() {
      return require("../assets/paperplane.png");
    },
    plane() {
      return require("../assets/plane.png");
    },
    companyDetails() {
      return this.$store.getters.companyDetails;
    },
    isActive() {
      return this.companyDetails.plan.active;
    },
  },
  created() {
    this.showHeader =
      localStorage.getItem("paymentsHeaderDismissed") !== "true";
    // this.getGeoLocViaIP();
    this.getLastPlan();
  },
  methods: {
    dismissHeader() {
      this.showHeader = false;
      localStorage.setItem("paymentsHeaderDismissed", "true");
    },
    handleOriginalUserCountUpdate(newOriginalCount) {
      this.originalUserCount = newOriginalCount;
    },
    setPaymentType(type) {
      this.selectedPaymentType = type;
    },
    getLastPlan() {
      var plan = this.companyDetails.plan;
      if (plan.name == "Trial") {
        // Trial Check Country
        this.showZoho = false;
        if (this.companyDetails.country == "India") {
          this.showZoho = true;
        }
      } else {
        // Check Previous Plan
        this.showZoho = true;
        if (plan.name == "GoDial Premium" || plan.name == "Godial Cloud PBX") {
          this.showZoho = false;
        }
      }
    },
  },
};
</script>
<style scoped>
/* Modern Design System */
.subscribe-container {
  background-color: var(--v-background-base, #f5f5f5);
  min-height: 100vh;
}

.theme--dark .subscribe-container {
  background-color: #121212 !important;
}

/* Legacy styles */
.v-toolbar__content {
  height: 0 !important;
}
.customBorder {
  border-style: solid;
  padding: 5px;
  margin: 10px;
  border-radius: 4px;
  width: 100%;
}
.centerimg {
  position: absolute;
  top: 30%;
  left: 30%;
}

.liveAccount {
  /* position: absolute; */
  height: 10px;
  width: 10px;
  border-radius: 50%;
  background: rgb(95, 255, 47);
  margin: 12px 10px;
}

.blue-black {
  color: #30475a;
}
</style>
